import React from "react";
import ReactDOM from "react-dom";
import { AppMain } from "app/AppMain";
import "./index.css";

ReactDOM.render(
	<React.StrictMode>
		<AppMain />
	</React.StrictMode>,
	document.getElementById("root")
);
